import { useEffect, useRef } from "react";
import { CommonPage, Content, PageTitle } from "common/Grid";
import { toast } from "react-toastify";
import { StaffUserForm } from "../Common/MainForm";
import { useAddStaffUserMutation } from "store/action/staffUserApi";
import { useNavigate } from "react-router-dom";
import { captureComponentError } from "utils/sentry";

const CreateStaffUser = () => {
  const [addStaffUser, { isLoading }] = useAddStaffUserMutation();
  const navigate = useNavigate();
  const successRef = useRef(false);

  useEffect(() => {
    return () => {
      if (!successRef.current) {
        toast.dismiss();
      }
    };
  }, []);

  const handleSubmit = async (userInput) => {
    try {
      const { phonePrefix, phoneNumber, ...rest } = userInput;
      const fullPhone = phoneNumber ? `${phonePrefix}${phoneNumber}` : undefined;

      const payload = {
        ...rest,
        email: rest?.email?.toLowerCase(),
        phoneNumber: fullPhone,
        pin: rest.pin || undefined,
        role: rest.role || undefined,
        username: rest.username || undefined,
        password: rest.password || undefined,
        siteid: rest.siteid || undefined,
      };
      const response = await addStaffUser({ body: payload }).unwrap();
      successRef.current = true;
      toast.success(response?.message || "Staff user created successfully");
      navigate("/staff-user");
    } catch (error) {
      toast.error(error?.data?.message || "Something went wrong!");
      captureComponentError(error, { component: "CreateStaffUser", action: "handleSubmit" });
    }
  };

  return (
    <CommonPage>
      <Content>
        <PageTitle title="Create Staff User" />
        <StaffUserForm onSubmit={handleSubmit} isLoading={isLoading} />
      </Content>
    </CommonPage>
  );
};

export default CreateStaffUser;
